import isEmailValid from './isEmailValid';

export default function hideEmail(email?: string): string {
  if (!email) return '';
  if (!isEmailValid(email)) return '';
  const [username, domain] = email.split('@');

  const hiddenUsername = username.length > 2 ? username.slice(0, 2) + '*'.repeat(username.length - 2) : '*'.repeat(username.length);
  const hiddenDomain = domain.length > 2 ? domain.slice(0, 2) + '*'.repeat(domain.length - 2) : '*'.repeat(domain.length);
  return `${hiddenUsername}@${hiddenDomain}`;
}
